import { computed } from 'vue';
import { CampaignImportDetails } from '@/models/campaign-import.interface';
import store from '@/store';

export default class CampaignImportBannerCode {
	public details = computed((): CampaignImportDetails | null => {
		return store.getters.campaignImportBannerDetails();
	});

	public dismiss(): void {
		store.mutations.setCampaignImportBannerDetails(null);
	}
}
